import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Empresa from '../views/Empresa.vue'
//import Depoimentos from '../views/Depoimentos.vue'
import Contato from '../views/Contato.vue'
import Produto from '../views/Produto.vue'
import Produtos from '../views/Produtos.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/empresa',
    name: 'empresa',
    component: Empresa
  }, {
    path: '/contato',
    name: 'contato',
    component: Contato
  }, 
  {
    path: '/produtos/:id',
    name: 'produto',
    component: Produto
  },
  {
    path: '/produtos',
    name: 'produtos',
    component: Produtos
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes
})

export default router
